import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/ProductsService.ts';


import {
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../store/RecordsSliceCaseHelpers';
import {Product} from '../types';

const entityKey = 'products';

interface ProductsState {
    byId: { [key: string]: Product },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as ProductsState;


const normalizeRecord = (record: Product) => {
    return Object.assign({}, record);
};

// generates pending, fulfilled and rejected
export const fetchProducts = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    () => {

        return fetchRecords({})
            .then((response) => {
                if (response) {
                    return response.map((record: Product) => {
                        return normalizeRecord(record);
                    });
                }
            });
    },
);

export const fetchProduct = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => {
                if (typeof response !== 'undefined') {
                    return normalizeRecord(response);
                }
            });
    });

export const saveProduct = createAsyncThunk(
    `${entityKey}/add`,
    (payload: Product) => {
        return add(payload)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const updateProduct = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: Product }) => {

        return update(id, record)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    },
);

export const deleteProduct = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id: string) => {
        return deleteRecord(id)
            .then(() => id);
    },
);


export const storeProduct = createAsyncThunk(
    `${entityKey}/store`,
    (payload: Product) => {
        return normalizeRecord(payload);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchProducts, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchProduct);

                                            // SAVE ONE
                                            saveOneCase(builder, saveProduct);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateProduct);

                                            updateOneCase(builder, storeProduct);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteProduct);
                                        },
                                    });

export default componentsSlice.reducer;
